import React from 'react';
import { Heading } from './index.styled';

const RenderLandingPage = () => {
    return <Heading>Featured Resources</Heading>;
};

export default RenderLandingPage;
